export const getSortParamArray = (
  activeSorting: { field: string; order: number }[] | undefined
) => {
  if (!activeSorting) {
    return [];
  }

  // Must be " " (space) between field and order to avoid double URL encoding
  return activeSorting.map(({ field, order }) =>
    order === -1 ? `${field} desc` : field
  );
};
